jQuery(document).ready(function ($) {

    var winHeight = $(window).height(),
            docHeight = $(document).height(),
            progressBar = $('progress'),
            lastScrollTop = 0,
            max, value;

    /* Set the max scrollable area */
    max = docHeight - winHeight;
    progressBar.attr('max', max);

    $(document).on('scroll', function () {
        value = $(window).scrollTop();
        progressBar.attr('value', value);
        var percentage_number = value / max * 100;
        var percentage = percentage_number + "%";
    });

});
